import { useState, useEffect, ReactNode } from "react";
import { useLocation } from "react-router-dom";
import { useAppSelector } from "../../store/hooks";
import Header from "../header/Header";
import LoadingSidebar from "../sidebar/LoadingSidebar";

interface LoadingLayoutProps {
  children: ReactNode;
}

const LoadingLayout: React.FC<LoadingLayoutProps> = ({ children }) => {
  const [isSidebarCollapsed, setIsSidebarCollapsed] = useState(false);
  const user = useAppSelector((state) => state.auth.user);
  const location = useLocation();

  const toggleSidebar = () => setIsSidebarCollapsed((prev) => !prev);

  useEffect(() => {
    console.log("📦 Current path:", location.pathname);
  }, [location]);

  const sidebarWidth = isSidebarCollapsed ? "w-16" : "w-64";

  return (
    <div className="min-h-screen bg-light dark:bg-dark text-dark dark:text-light transition-colors">
      {/* Sidebar */}
      <div
        className={`fixed inset-y-0 left-0 z-40 ${sidebarWidth} bg-slate-900 text-white transition-all duration-300`}
      >
        <LoadingSidebar isCollapsed={isSidebarCollapsed} />
      </div>

      {/* Main Content */}
      <div
        className={`min-h-screen flex flex-col transition-all duration-300 ${
          isSidebarCollapsed ? "md:pl-16" : "md:pl-64"
        }`}
      >
        <Header
          onToggleSidebar={toggleSidebar}
          isCollapsed={isSidebarCollapsed}
          user={user ? { name: user.name!, role: user.role! } : null}
        />

        {/* Optional Welcome */}
        {user && (
          <div className="px-6 pt-4 text-sm text-slate-600 dark:text-slate-300">
            Welcome <strong>{user.name}</strong> ({user.role})
          </div>
        )}

        <main className="pt-pt-14 px-2">{children}</main>
      </div>
    </div>
  );
};

export default LoadingLayout;
